/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import {
  TextField as MuiTextField,
  IconButton as MuiIconButton,
  Avatar as MuiAvatar,
  Avatar as Logo,
  Badge,
  MenuItem,
  Box,
  Popover as MuiPopover,
  AppBar as MuiAppBar,
} from '@mui/material';
import styled from '@emotion/styled';
import { spacing } from '@mui/system';
import { Edit, Info } from 'react-feather';
/**
 * Styles for navigation bar component
 */

export const TextField = styled(MuiTextField)(spacing);
//
export const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;
//
export const Popover = styled(MuiPopover)`
  .MuiPaper-root {
    width: 300px;
    ${(props) => props.theme.shadows[1]};
    border: 1px solid ${(props) => props.theme.palette.divider};
  }
`;
//
export const Indicator = styled(Badge)`
  .MuiBadge-badge {
    background: ${(props) => props.theme.header.indicator.background};
    color: ${(props) => props.theme.palette.common.white};
  }
`;
//
export const Avatar = styled(MuiAvatar)`
  background: ${(props) => props.theme.palette.primary.main};
`;
//
export const MessageHeader = styled(Box)`
  text-align: center;
  border-bottom: 1px solid ${(props) => props.theme.palette.divider};
`;
//
export const NotificationHeader = styled(Box)`
  text-align: center;
  border-bottom: 1px solid ${(props) => props.theme.palette.divider};
`;
//
export const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;
//
export const LargeAvatar = styled(Logo)`
  width: 150px;
  height: 60px;
  text-align: left;
`;
//
export const SmallAvatar = styled(Logo)`
  margin-top: 15px;
  width: 100px;
  text-align: left;
`;
//
export const MenuItemDropdownItem = styled(MenuItem)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

export const CustomEditIcon = styled(Edit)(() => ({
  color: 'white',
  '.Mui-disabled &': {
    color: '#9e9e9e',
  },
}));

export const CustomInfoIcon = styled(Info)(() => ({
  color: 'white',
  '.Mui-disabled &': {
    color: '#9e9e9e',
  },
}));
